import { getString } from "../../common/common";

export const PHONE_NUM = 'Phone_No.';
export const PHONE_NUM_ERR = 'Enter_valid_mobile_no';
export const EMAIL_ID = 'Email_ID';
export const EMAIL_ID_ERR = 'Enter_valid_email_id';


export const translations = {
    en: {
        [PHONE_NUM]: 'Mobile No.',
        [PHONE_NUM_ERR]: 'Enter valid mobile no',
        [EMAIL_ID]: 'Email ID',
        [EMAIL_ID_ERR]: 'Enter valid email id',
    },
    kn: {
        [PHONE_NUM]: 'ಫೋನ್ ನಂಬರ್.',
        [PHONE_NUM_ERR]: 'ಸರಿಯಾದ ಮೊಬೈಲ್ ನಂಬರ್ ಎಂಟರ್ ಮಾಡಿ',
        [EMAIL_ID]: 'ಇಮೇಲ್ ಐಡಿ',
        [EMAIL_ID_ERR]: 'ಸರಿಯಾದ ಇಮೇಲ್ ಐಡಿ ಎಂಟರ್ ಮಾಡಿ',
    },
};

export const t = (key = "") => {
    return getString(key, translations)
}